// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pf-draft-approval{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:var(--space-static-s-1s7ia4, 12px)}.pf-draft-approval p{margin-bottom:0}.pf-draft-approval-actions{display:flex;flex-wrap:wrap;gap:var(--space-static-xs-e1v9ps, 8px)}", ""]);
// Exports
module.exports = exports;
